
import FormViewer from "../../../../Component/Application/form/CreateTag/CreateTag";

const ViewForm = () => {
  return (
    <div className="page-body">
      <FormViewer />
    </div>
  );
};

export default ViewForm;
